import { useTranslation } from "react-i18next";
import { Box, Skeleton, Typography } from "@mui/material";

import { ServiceContract } from "../../../../../types/service.type";

export const ContractDetailsCard = ({ contractDetails }: { contractDetails: ServiceContract }) => {
  const { t } = useTranslation("goService", { keyPrefix: "serviceRequestPage" });
  const {
    paymentConfig: { amount, currency, type },
    milestones,
  } = contractDetails;

  const totalContractAmount =
    type === "fixed" ? amount / 100 : (amount / 100) * (milestones?.length ? milestones?.length : 1);
  const totalContractPrice = `${totalContractAmount.toFixed(2)} ${currency}`;

  const contractDetailsList = [
    {
      label: t("totalContractPrice"),
      value: totalContractPrice,
    },
    {
      label: t("willKeepInEscrow"),
      value: totalContractPrice,
    },
    {
      label: t("numberOfMilestones"),
      value: milestones.length,
    },
    {
      label: t("milestonesPrice"),
      value: `${(amount / 100).toFixed(2)} ${currency}`,
    },
  ];

  return (
    <Box sx={styles.container}>
      {contractDetailsList.map(({ label, value }, index) => (
        <Box key={index} sx={styles.labelContainer}>
          <Typography component="label" sx={styles.label}>
            {label}
          </Typography>
          <Typography component="span" sx={styles.value}>
            {value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export const ContractDetailsCardLoader = () => {
  return (
    <Box sx={styles.container}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Box key={index} sx={styles.labelContainer}>
          <Skeleton variant="text" width="50%" height="18px" />
          <Skeleton variant="text" width="30%" height="24px" />
        </Box>
      ))}
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    gap: "24px 16px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--Gray---25, #F7F8F8)",
    padding: "16px",
  },
  labelContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    width: "calc(50% - 8px)",
    flexShrink: 0,
  },
  label: {
    color: "var(--Dark---800, #414141)",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "18px",
  },
  value: {
    color: "var(--Dark---900, #1A1C21)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
};
